import { settingsCopy } from '@/copy'
import { workspaceProvidersApi } from '../../api/agents'
import { ProviderList } from '../../components/ProviderList'
import { useProviderCrud } from '../../hooks/useProviderCrud'

export function ProvidersTab({
  wsId,
  canManage,
  canCreate,
  creating,
  onCreatingChange,
}: {
  wsId: string
  canManage: boolean
  canCreate: boolean
  creating: boolean
  onCreatingChange: (open: boolean) => void
}) {
  const crud = useProviderCrud({
    queryKey: ['workspace-providers', wsId],
    api: {
      list: () => workspaceProvidersApi.list(wsId),
      create: (body) => workspaceProvidersApi.create(wsId, body),
      update: (id, body) => workspaceProvidersApi.update(wsId, id, body),
      delete: (id) => workspaceProvidersApi.delete(wsId, id),
    },
    invalidateKeys: [['providers', wsId]],
    enabled: !!wsId,
    staleTime: 60_000,
  })

  return (
    <ProviderList
      {...crud}
      canManage={canManage}
      creating={creating}
      onCreatingChange={onCreatingChange}
      canCreate={canCreate}
      emptyText={
        canManage
          ? settingsCopy.providers.workspaceEmptyManager
          : settingsCopy.providers.workspaceEmptyMember
      }
      autoFocusName
    />
  )
}
